import type { CancellationListItem } from "@/app/booking-calendar/api/cancellationsApi"

/** AmsBookingActor, as the API serializes it (a number). */
export const BookingActor = {
  Unknown: 0,
  Attendee: 1,
  Staff: 2,
  System: 3,
} as const

/** Who cancelled, for display: the staff member when known, otherwise the kind of actor. */
export function describeCanceller(item: Pick<CancellationListItem, "cancelledBy" | "cancelledByActor">): string {
  if (item.cancelledBy) return item.cancelledBy
  switch (item.cancelledByActor) {
    case BookingActor.Attendee: return "Attendee"
    case BookingActor.Staff: return "Staff"
    case BookingActor.System: return "System"
    default: return "Unknown"
  }
}
